require('./personeticsPGBox.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');

class PersoneticsPGBox extends React.Component {
    constructor(props) {
        super(props);

        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    handleButtonClick() {
        this.props.onButtonClick();
    }

    render() {
        const {
            buttonText,
            description,
            modifier,
            title
        } = this.props;

        return (
            <div className="personetics-pg-box">
                <div className="personetics-pg-box__title">
                    {title}
                </div>
                <div className="personetics-pg-box__description">
                    {description}
                </div>
                <div className="personetics-pg-box__cta">
                    <OKButton modifier={modifier} onClick={this.handleButtonClick}>
                        {buttonText}
                    </OKButton>
                </div>
            </div>
        );
    }
}

PersoneticsPGBox.propTypes = {
    buttonText: PropTypes.string,
    description: PropTypes.string,
    modifier: PropTypes.string,
    onButtonClick: PropTypes.func,
    title: PropTypes.string
};

module.exports = PersoneticsPGBox;
